document.addEventListener('DOMContentLoaded', () => {
  const cards = document.querySelectorAll('[data-joh-product-card]');

  cards.forEach((card) => {
    const buttons = card.querySelectorAll('[data-joh-color-button]');
    const primaryImage = card.querySelector('[data-joh-product-image-primary]');
    const secondaryImage = card.querySelector('[data-joh-product-image-secondary]');
    const priceContainer = card.querySelector('[data-joh-product-price]');
    const links = card.querySelectorAll('[data-joh-product-link]');

    if (!buttons.length) return;

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((btn) => {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-pressed', 'false');
        });

        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');

        const swatch = button.querySelector('[data-joh-swatch-image]');
        if (!swatch) return;

        const primarySrc = swatch.dataset.primaryImage;
        const secondarySrc = swatch.dataset.secondaryImage;
        const priceHtml = swatch.dataset.priceHtml;
        const newUrl = button.dataset.productUrl;

        if (primaryImage && primarySrc) {
          primaryImage.src = primarySrc;
          primaryImage.srcset = '';
        }

        if (secondaryImage && secondarySrc) {
          secondaryImage.src = secondarySrc;
          secondaryImage.srcset = '';
        }

        if (priceContainer && priceHtml) {
          priceContainer.innerHTML = priceHtml;
        }

        if (links.length && newUrl) {
          links.forEach((link) => {
            link.href = newUrl;
          });
        }
      });
    });
  });
});